// extracted by mini-css-extract-plugin
module.exports = {"floating-loader":"floating-loader__1moiQ","loader-svg":"loader-svg__38WDM"};